module.exports = __webpack_public_path__ + "img/ico_youtube.0ea7818e.svg";